import React, {useEffect, useState} from "react"
import {DefaultTablePagination, InputBox, Modal, notification, Table} from "../../../components/Elements/appUtils";
import axios from "axios";
import {getbatchRecordByProductIdUrl} from "../api";
import {getToken} from "../../../request";

const UpdateDiscount = (props) => {
    let {onClose, data, visible, index, onSubmit} = props;
    let [discount, setDiscount] = useState(0);
    let [quantity, setQuantity] = useState(0);
    let [batch, setBatch] = useState([]);
    let [selectedBatch, setSelectedBatch] = useState(data);
    useEffect(() => {
        setDiscount(data?.discount || 0);
        setQuantity(data?.quantity || 0);
        setSelectedBatch(data || {});

        if (data?.productId) {
            fetchBatch(data.productId);
        } else {
            setBatch([]);
        }
    }, [data]);

    const chooseBatch = (batchData) => {
        if (batchData.quantity) {
            setSelectedBatch((prevData) => {
                return {
                    ...prevData,
                    batchQuantity: batchData.quantity,
                    batchId: batchData._id,
                    batchNo: batchData.batchNo,
                    price: batchData.salePrice ? batchData.salePrice : 0,
                    manufacturingDate: batchData.manufacturingDate,
                    expiryDate: batchData.expiryDate,
                    salePrice: batchData.salePrice
                }
            })
            setQuantity(1);
        } else {
            notification.warning({
                message: "Quantity not exists in this batch.",
            });
        }
    }


    const fetchBatch = async (productId) => {
        try {
            const response = await axios.get(getbatchRecordByProductIdUrl(), {
                params: {productId},
                ...(await getToken()),
            });
            setBatch(Array.isArray(response.data?.data) ? response.data.data : []);
        } catch (error) {
            console.error("Error getting the data:", error);
        }
    };

    const submitFxn = () => {
        const enteredQuantity = Number(quantity);
        const enteredDiscount = Number(discount);
        const availableQuantity = Number(selectedBatch.batchQuantity || selectedBatch.BatchQunatity || 0);

        if (!enteredQuantity || enteredQuantity < 1) {
            notification.warning({message: "Please enter a valid quantity."});
            return;
        }
        if (enteredDiscount < 0 || enteredDiscount > 100) {
            notification.warning({message: "Please enter a discount between 0 and 100."});
            return;
        }
        if (enteredQuantity > availableQuantity) {
            notification.warning({
                message: `Please enter valid quantity, Batch Quantity - ${availableQuantity}`,
            });
            return
        }
        onSubmit(index, {
            ...selectedBatch,
            batchQuantity: availableQuantity,
            BatchQunatity: availableQuantity,
            discount: enteredDiscount,
            quantity: enteredQuantity
        })
    }

    const columns = [
        {
            title: "Batch Number",
            dataIndex: "batchNo",
            key: "batchNo",
        },
        {
            title: "Mfg Date",
            dataIndex: "manufacturingDateString",
            key: "manufacturingDateString",
        },
        {
            title: "Exp Date",
            dataIndex: "expiryDateString",
            key: "expiryDateString",
        },
        {
            title: "Quantity",
            dataIndex: "quantity",
            key: "quantity",
        },
        {
            title: "Action",
            key: "actions",
            render: (_, record) => {
                return (
                    <>
                        <button
                            onClick={() => {
                                chooseBatch(record)
                            }}
                            className={`btn ${record._id === selectedBatch.batchId ? "btn-info" : "btn-default-new"} btn-xs rounded`}>
                            {record._id === selectedBatch.batchId ? "Selected" : "Select"}
                        </button>
                    </>
                )
            }
        },
    ]

    return (
        <Modal title={'Update Discount'}
               visible={visible}
               width={'42%'}
               onClose={onClose}>
            <div className={'row'}>
                <div className={'col-md-5'}>
                    <InputBox title={'Quantity'}>
                        <input value={quantity}
                               type={'number'}
                               className={'form-control'} onChange={({target}) => {
                            setQuantity(target.value)
                        }}/>
                    </InputBox>
                </div>
                <div className={'col-md-4'}>
                    <InputBox title={'Discount'}>
                        <input value={discount}
                               type={'number'}
                               className={'form-control'} onChange={({target}) => {
                            setDiscount(target.value)
                        }}/>
                    </InputBox>
                </div>
                <div className={'col-md-3'} style={{marginTop: 20, textAlign: "right"}}>
                    <button type="submit" className="btn btn-gradient-info btn-md" onClick={() => {
                        submitFxn();
                    }}>
                        Update
                    </button>
                </div>
                <div className={'col-md-12'}>
                    <br/>
                    <Table
                        key={selectedBatch.batchId || "no-batch-selected"}
                        columns={columns}
                        dataSource={batch}
                        pagination={{
                            ...DefaultTablePagination(),
                            defaultPageSize: 10,
                            pageSize: 10,
                            pageSizeOptions: ["10", "25", "50", "100"]
                        }}
                    />

                    {/*<table className="table table-bordered">
                        <thead>
                        <tr>
                            <td>Batch Number</td>
                            <td>Mfg Date</td>
                            <td>Exp Date</td>
                            <td>Quantity</td>
                            <td>Action</td>
                        </tr>
                        </thead>
                        <tbody>
                        {batch.map((item) => (
                            <tr key={item.id}>
                                <td>{item.batchNo}</td>
                                <td>{item.manufacturingDateString}</td>
                                <td>{item.expiryDateString}</td>
                                <td>{item.quantity}</td>
                                <td>
                                    <button
                                        onClick={() => {
                                            chooseBatch(item)
                                        }}
                                        className={`btn ${item._id == selectedBatch.batchId ? "btn-info" : "btn-default-new"}  btn-xs rounded`}>
                                        {item._id == selectedBatch.batchId ? "Selected" : "Select"}
                                    </button>
                                </td>
                            </tr>
                        ))}
                        </tbody>
                    </table>*/}
                </div>

            </div>


        </Modal>
    )
}
export default UpdateDiscount
